import React, { useEffect, useMemo, useState } from "react";
import { Row, Card, CardBody, Col } from "reactstrap";
import { ReactifyChartColors } from "Util/ReactifyChartColors";
import { SPARKLINES_CONTAINER_FULL_WIDTH } from "Constants/reactifyInlineStyles";

import {
  Sparklines,
  SparklinesLine,
  SparklinesBars,
  SparklinesSpots
} from "react-sparklines";

const sparklineData = [936, 968, 1025, 999, 998, 1014, 1017, 1010, 1010, 1007];
const sparklineSubs = [936, 968, 936, 930, 998, 1014, 1014, 1010, 900, 1007];

function boxMullerRandom() {
  let phase = false;
  let x1 = 0;
  let x2 = 0;
  let w = 0;

  return (function () {
    if ((phase = !phase)) {
      do {
        x1 = 2.0 * Math.random() - 1.0;
        x2 = 2.0 * Math.random() - 1.0;
        w = x1 * x1 + x2 * x2;
      } while (w >= 1.0);

      w = Math.sqrt((-2.0 * Math.log(w)) / w);
      return x1 * w;
    }
    return x2 * w;
  })();
}

export default function SparklinePage() {
  const [liveData, setLiveData] = useState<number[]>([]);
  const colors = useMemo(() => ReactifyChartColors(), []);
  const c1 = colors.ReactifyChartColor1;

  const barsFilled = useMemo(
    () =>
      ({
        stroke: c1,
        strokeWidth: "1",
        fill: c1
      }) as const,
    [c1]
  );

  const lineOutline1 = useMemo(
    () =>
      ({
        stroke: c1,
        strokeWidth: "1",
        fill: "none" as const
      }),
    [c1]
  );

  const lineOutline2 = useMemo(
    () => ({ stroke: c1, fill: "none" as const }),
    [c1]
  );

  const spotsFill = useMemo(
    () =>
      ({
        stroke: "none" as const,
        fill: c1
      }),
    [c1]
  );

  const barsSoft = useMemo(
    () =>
      ({
        stroke: c1,
        fill: c1,
        fillOpacity: ".25"
      }) as const,
    [c1]
  );

  const liveLine = useMemo(
    () =>
      ({
        stroke: c1,
        fill: "none" as const,
        fillOpacity: "1" as const
      }),
    [c1]
  );

  useEffect(() => {
    const id = setInterval(() => {
      setLiveData(prev => prev.concat([boxMullerRandom()]));
    }, 100);
    return () => clearInterval(id);
  }, []);

  return (
    <div>
      <Row>
        <Col lg="6" className="mb-5">
          <Card>
            <CardBody>
              <Sparklines data={sparklineData} style={SPARKLINES_CONTAINER_FULL_WIDTH}>
                <SparklinesBars style={barsFilled} />
              </Sparklines>
            </CardBody>
          </Card>
        </Col>
        <Col lg="6" className="mb-5">
          <Card>
            <CardBody>
              <Sparklines data={sparklineSubs}>
                <SparklinesLine style={barsFilled} />
              </Sparklines>
            </CardBody>
          </Card>
        </Col>
      </Row>
      <Row>
        <Col lg="6" className="mb-5">
          <Card>
            <CardBody>
              <Sparklines data={sparklineData}>
                <SparklinesLine style={lineOutline1} />
              </Sparklines>{" "}
            </CardBody>
          </Card>
        </Col>
        <Col lg="6" className="mb-5">
          <Card>
            <CardBody>
              <Sparklines data={sparklineData}>
                <SparklinesLine style={lineOutline2} />
                <SparklinesSpots style={spotsFill} />
              </Sparklines>
            </CardBody>
          </Card>
        </Col>
      </Row>
      <Row>
        <Col lg="6" className="mb-5">
          <Card>
            <CardBody>
              <Sparklines data={sparklineData}>
                <SparklinesBars style={barsSoft} />
                <SparklinesLine style={lineOutline2} />
              </Sparklines>
            </CardBody>
          </Card>
        </Col>
        <Col lg="6" className="mb-5">
          <Card>
            <CardBody>
              <Sparklines data={liveData} limit={20}>
                <SparklinesLine style={liveLine} />
                <SparklinesSpots style={spotsFill} />
              </Sparklines>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </div>
  );
}
